import { Domain as AuthDomain } from 'auth-common/domain';

import Project = AuthDomain.Object.Project;

import { dayjs } from '../../../shared/utils/date';
import type { AggregationRoot } from '../common';

export type FeatureFlag = AggregationRoot & {
  flags: FeatureFlag.Flags;
  createdAt: dayjs;
  updatedAt: dayjs;
  updatedBy: string;
};

export namespace FeatureFlag {
  export type Flags = {
    /** CSV 解析で Vertex の列マッピング推定を使うか。未設定は true と同様。 */
    csvLlmAnalysisEnabled: boolean;
  };

  // 各フラグの明示的なデフォルト値。新しいフラグを追加するときはここにも必ず追加する。
  export const DefaultFlags: Flags = {
    csvLlmAnalysisEnabled: true,
  };

  function parseFlags(raw: unknown): Flags {
    if (raw === null || typeof raw !== 'object') return { ...DefaultFlags };
    const o = raw as Record<string, unknown>;
    return {
      csvLlmAnalysisEnabled: typeof o.csvLlmAnalysisEnabled === 'boolean' ? o.csvLlmAnalysisEnabled : DefaultFlags.csvLlmAnalysisEnabled,
    };
  }

  type ConstructProps = {
    projectId: string;
    flags: unknown;
    createdAt: string | Date | dayjs;
    updatedAt: string | Date | dayjs;
    updatedBy: string;
  };

  export const Construct = (props: ConstructProps): FeatureFlag => {
    return {
      projectId: Project.Id.FromString(props.projectId),
      flags: parseFlags(props.flags),
      createdAt: dayjs(props.createdAt),
      updatedAt: dayjs(props.updatedAt),
      updatedBy: props.updatedBy,
    };
  };

  export namespace Create {
    export type Params = {
      projectId: Project.Id;
      user: string;
      flags?: Partial<Flags>;
    };
  }

  export const Create = (params: Create.Params): FeatureFlag => {
    const { projectId, user, flags } = params;
    const date = dayjs(new Date());
    return {
      projectId,
      flags: { ...DefaultFlags, ...flags },
      createdAt: date,
      updatedAt: date,
      updatedBy: user,
    };
  };

  export namespace Update {
    export type Params = {
      current: FeatureFlag;
      props: {
        flags?: Partial<Flags>;
      };
      user: string;
    };
  }

  export const Update = (params: Update.Params): FeatureFlag => {
    const { current, props, user } = params;
    return {
      ...current,
      flags: props.flags !== undefined ? { ...current.flags, ...props.flags } : current.flags,
      updatedAt: dayjs(new Date()),
      updatedBy: user,
    };
  };
}
